import {useTranslation} from "react-i18next";
import {
    faArrowUpRight,
    faAt,
    faCircleQuestion,
    faClock,
    faEnvelope,
    faLocationDot,
    faPhone
} from "@fortawesome/pro-solid-svg-icons";

import {Styled} from "./Contact.styles";
import {Editorial} from "../../Styles/editorial";
import ActionButton from "../../lib/UIBookBrd/ActionButton";
import Reveal from "../../lib/UIBookBrd/Reveal";
import useS115 from "../../lib/Hooks/useS115";
import {Contact__Values} from "../../PageValues";
import {RENT_LIST_PAGE} from "../../Routes";

const ContactPage = () => {

    const {t} = useTranslation()

    const {navigatePage} = useS115()

    const phone = Contact__Values.phoneNumbers[0]

    const links = [
        {
            labelKey: 'lbl_call_us',
            value: phone,
            href: `tel:${phone.replace(/\s/g, '')}`,
            icon: faPhone,
            external: false
        },
        {
            labelKey: 'lbl_write_email',
            value: Contact__Values.emailAddress,
            href: `mailto:${Contact__Values.emailAddress}`,
            icon: faEnvelope,
            external: false
        },
        {
            labelKey: 'lbl_dm_instagram',
            value: Contact__Values.instagramHandle,
            href: Contact__Values.instagram,
            icon: faAt,
            external: true
        }
    ]

    return (
        <Editorial.Page>
            <Editorial.Head>
                <Editorial.Eyebrow>{t('lbl_contact')}</Editorial.Eyebrow>
                <Editorial.PageTitle>{t('lbl_contact_title')}</Editorial.PageTitle>
                <Editorial.Lead>{t('lbl_contact_lead')}</Editorial.Lead>
                <Editorial.ChipRow style={{marginTop: '4px'}}>
                    <Editorial.Chip>
                        <Editorial.ChipIcon icon={faLocationDot}/>
                        {`${Contact__Values.city}, ${t('lbl_poland')}`}
                    </Editorial.Chip>
                    <Editorial.Chip>
                        <Editorial.ChipIcon icon={faClock}/>
                        {t('lbl_response_time')}
                    </Editorial.Chip>
                </Editorial.ChipRow>
            </Editorial.Head>

            <Styled.Links>
                {links.map((link, index) => (
                    <Reveal key={link.labelKey} index={index}>
                        <Editorial.LinkCard
                            href={link.href}
                            target={link.external ? '_blank' : undefined}
                            rel={link.external ? 'noreferrer' : undefined}
                        >
                            <Editorial.LinkCardIconRing>
                                <Editorial.LinkCardIcon icon={link.icon}/>
                            </Editorial.LinkCardIconRing>
                            <Editorial.LinkCardText>
                                <Editorial.LinkCardLabel>{t(link.labelKey)}</Editorial.LinkCardLabel>
                                <Editorial.LinkCardValue>{link.value}</Editorial.LinkCardValue>
                            </Editorial.LinkCardText>
                            <Editorial.LinkCardArrow icon={faArrowUpRight}/>
                        </Editorial.LinkCard>
                    </Reveal>
                ))}
            </Styled.Links>

            <Styled.Info>
                <Reveal index={0}>
                    <Editorial.Card>
                        <Editorial.CardIcon icon={faEnvelope}/>
                        <Editorial.CardTitle>{t('lbl_want_to_reserve')}</Editorial.CardTitle>
                        <Editorial.CardText>{t('lbl_want_to_reserve_desc')}</Editorial.CardText>
                    </Editorial.Card>
                </Reveal>
                <Reveal index={1}>
                    <Editorial.Card>
                        <Editorial.CardIcon icon={faCircleQuestion}/>
                        <Editorial.CardTitle>{t('lbl_not_know_what_want')}</Editorial.CardTitle>
                        <Editorial.CardText>{t('lbl_not_know_what_want_desc')}</Editorial.CardText>
                    </Editorial.Card>
                </Reveal>
            </Styled.Info>

            <Editorial.Section>
                <Editorial.CtaPanel>
                    <Editorial.CtaText>
                        <Editorial.Eyebrow>{t('lbl_rent_equipment')}</Editorial.Eyebrow>
                        <Editorial.SectionTitle>{t('lbl_contact_cta_title')}</Editorial.SectionTitle>
                        <Editorial.Lead>{t('lbl_contact_cta_lead')}</Editorial.Lead>
                    </Editorial.CtaText>
                    <Editorial.CtaActions>
                        <ActionButton
                            size={'lg'}
                            iconRight={faArrowUpRight}
                            label={t('lbl_see_all_offer')}
                            onClick={() => navigatePage(RENT_LIST_PAGE)}
                        />
                    </Editorial.CtaActions>
                </Editorial.CtaPanel>
            </Editorial.Section>
        </Editorial.Page>
    )
}

export default ContactPage
